import { URLS } from 'api/constants';
import { IComplaint } from 'constants/types';
import { useLazyQuery } from 'hooks/useQuery';
import { useMutation } from 'hooks/useMutation';
import { apiGet, apiRequest } from 'lib/api/client';
import { PaginationResponse } from 'lib/api/types';

interface ComplaintsRequest {
  page?: number;
  limit?: number;
  parentId?: string;
}

interface CreateCasinoComplaintRequest {
  image?: File;
  message: string;
  casinoId: string;
  title: string;
  replyId?: string;
  parent: string | null;
}

export const useLazyComplaintsQuery = () =>
  useLazyQuery<PaginationResponse<IComplaint>, ComplaintsRequest>(
    ({ page, limit, parentId }) =>
      apiGet<PaginationResponse<IComplaint>>(URLS.COMPLAINTS, {
        page,
        limit,
        parent_id: parentId,
      })
  );

export const useCreateCasinoComplaintsMutation = () =>
  useMutation<CreateCasinoComplaintRequest, IComplaint>(
    ({ casinoId, title, message, parent, replyId, image }) => {
      const formData = new FormData();
      formData.append('casino_id', casinoId);
      formData.append('message', message);
      formData.append('title', title);

      if (parent) {
        formData.append('parent', parent);
      }

      if (replyId) {
        formData.append('reply_id', replyId);
      }

      if (image) {
        formData.append('image', image);
      }

      return apiRequest<IComplaint>(URLS.COMPLAINTS, {
        method: 'POST',
        auth: true,
        body: formData,
      });
    }
  );
